import React from "react";
import { Modal } from "../../molecules/Modal";
import { ListingItem } from "./ListingItem";
import { useListingModal } from "./controller";

export const ListingItemModal = () => {
    const { closeListing, isOpen, listingItemSlug } = useListingModal();

    return (
        <Modal isVisible={isOpen} alignTopOnSmall maxWidth={1050} onClose={closeListing}>
            {<ListingItem slug={listingItemSlug} />}
        </Modal>
    );
};
